import { useEffect } from 'react';
import { Typography, Box, Link } from "@mui/material";
import { useDropHandle } from './hooks/useDropHandle';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ChangeAlertCallbackType } from '../../Root';

export type DropZoneProps = {
    typeFile: Array<string>;
    clickOpen?: boolean;
    handleFile: Function;
    changeAlert: ChangeAlertCallbackType;
};

const DropZone = ({ typeFile, clickOpen, handleFile, changeAlert }: DropZoneProps) => {
    const { dropZoneRef, handleOver, handleLeave, handleDrop, onSelectFile, formatExtensions } = useDropHandle(typeFile, handleFile, changeAlert);

    const addFile = () => {
        document.getElementById("file")?.click();
    };

    useEffect(() => {
        document && clickOpen && addFile();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [document]);

    return (
        <>
            <Box 
                ref={dropZoneRef} onDragLeave={handleLeave} onDragOver={handleOver} onDrop={handleDrop} onClick={addFile.bind(this, "")}
                sx={{p: 3, mb: 1, mt: 3, border: "4px dashed lightgray", textAlign: "center", cursor: "pointer"}}>
                <CloudUploadIcon fontSize="large" color="action" sx={{m: 1}}/>
                <Typography variant="body2">
                    Arrastra y suelta tu archivo o <Link>cárgalo desde tus documentos</Link>
                </Typography>
                <input id="file" type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style={{ display: "none" }} onChange={onSelectFile.bind(this)}/>
            </Box>
            <Typography variant="body2">Formatos válidos: {formatExtensions(typeFile)}.</Typography>
        </>          
    );
};

export default DropZone;
